import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import styles from './LicenseExpiringModal.module.scss';

const LicenseExpiringModal = ({ isOpen, onClose, daysRemaining }) => {
  const daysText = daysRemaining === 1 ? 'day' : 'days';

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className={styles.modal} overlayClassName={styles.overlay}>
      <div className={styles.content}>
        <h2>Your license expires soon</h2>
        <p>
          Hello! Just a quick reminder that your current license will expire in {daysRemaining} {daysText}.
        </p>
        <p>
          To avoid any interruption to your course or access, please check with your manager or L&amp;D team to review your options and ensure your
          license is renewed before the expiration date.
        </p>
        <p>
          If you have questions or need help, our support team is happy to assist at{' '}
          <a href="mailto:courses@chatterbox.io" className={styles.email}>
            courses@chatterbox.io
          </a>
          .
        </p>
        <div className={styles.buttons}>
          <button className={styles.confirmButton} onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </Modal>
  );
};

LicenseExpiringModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  daysRemaining: PropTypes.number.isRequired
};

export default LicenseExpiringModal;
